// =============================================================================
// index.web.js — CRYB WEB entry (react-native-web).
//
// The web build of the ONE native RN codebase (CRYB native-only strategy, domain
// app.cryb.ai). ONE codebase → iOS via index.js, tablet/desktop browsers via this
// file. Native (index.js) is untouched.
//
// Boot order:
//   1. MobileWebGate — phone-class browsers get the "Download the app" screen and
//      the app never mounts. Tablet + desktop render the full app.
//   2. AppRegistry.runApplication into #root (RNW).
//
// The native-only modules (keychain/livekit/webrtc/image-picker/video/…) are
// redirected to web shims by webpack aliases (webpack.config.js) so this bundle
// compiles; each shim degrades its feature gracefully on web.
// =============================================================================
import 'react-native-get-random-values';
import React from 'react';
import { AppRegistry } from 'react-native';
import App from './App';
import MobileWebGate from './components/MobileWebGate';
import { name as appName } from './app.json';

function WebRoot() {
  return (
    <MobileWebGate>
      <App />
    </MobileWebGate>
  );
}

AppRegistry.registerComponent(appName, () => WebRoot);

AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
